/** Purchase helpers use the existing product component as the state owner. */
(() => {
function syncBuyClearance(slide) {
        if (!slide.detailsScroll || !slide.stickyBuy) return;
        const scroll = slide.detailsScroll.getBoundingClientRect();
        const buy = slide.stickyBuy.getBoundingClientRect();
        if (!scroll.height || !buy.height) return;
        const clearance = Math.ceil(Math.max(0, scroll.bottom - buy.top) + 16);
        const value = `${clearance}px`;
        if (slide.style.getPropertyValue('--tbhnp-buy-clearance') !== value) {
          slide.style.setProperty('--tbhnp-buy-clearance', value);
        }
      }


function recommendedSizeVariant(slide, size) {
        const group = slide.querySelector('[data-glass-option="size"]');
        const button = [...(group?.querySelectorAll('[data-option-button]') || [])]
          .find((item) => item.dataset.optionValue === size);
        if (!button) return null;
        const options = [...slide.selectedOptions];
        options[Number(button.dataset.optionIndex)] = size;
        return slide.findVariant(options);
      }


function applyRecommendedSize(slide, size) {
        if (slide.busy || !slide.recommendedSizeVariant(size)?.available) return false;
        const group = slide.querySelector('[data-glass-option="size"]');
        const button = [...(group?.querySelectorAll('[data-option-button]') || [])]
          .find((item) => item.dataset.optionValue === size);
        if (!button || button.disabled) return false;
        slide.selectOption(button, { preserveMedia: true });
        return true;
      }


window.TBHNPPurchaseControls = { syncBuyClearance, recommendedSizeVariant, applyRecommendedSize };
})();
